import { useEffect, useState } from "react";
import { MoonStar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import api from "@/lib/api";

const HOURS = Array.from({ length: 24 }, (_, i) => i);

export default function QuietHoursDialog({ trigger, defaultOpen = false, onClosed }) {
  const [open, setOpenState] = useState(defaultOpen);
  const setOpen = (v) => { setOpenState(v); if (!v) onClosed?.(); };
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.waSettings().then(setS).catch(() => toast.error("Impostazioni non disponibili")); }, [open]);
  const save = async () => {
    setBusy(true);
    try { await api.saveWaSettings({ ...s, automation_secret: "" }); toast.success("Fascia notturna salvata"); setOpen(false); } catch (e) { toast.error(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  const sel = (k) => (
    <select value={s[k]} onChange={(e) => setS({ ...s, [k]: parseInt(e.target.value, 10) })} className="h-9 rounded-md border border-border bg-background px-2 text-sm" data-testid={`quiet-${k}`}>
      {HOURS.map((h) => <option key={h} value={h}>{String(h).padStart(2, "0")}:00</option>)}
    </select>
  );
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || <Button variant="outline" className="gap-2 border-border" data-testid="open-quiet-hours-button"><MoonStar className="h-4 w-4" /> Fascia notturna</Button>}
      </DialogTrigger>
      <DialogContent className="bg-background border-border" data-testid="quiet-hours-dialog">
        <DialogHeader><DialogTitle>Fascia notturna WhatsApp</DialogTitle><DialogDescription>I messaggi WhatsApp generati in questa fascia (ora italiana) vengono messi in coda e inviati alla fine della fascia.</DialogDescription></DialogHeader>
        {s && (
          <div className="space-y-4">
            <div className="flex items-center justify-between rounded-md border border-border px-3 py-2"><Label htmlFor="quiet-enabled">Attiva fascia notturna</Label><Switch id="quiet-enabled" checked={s.quiet_enabled} onCheckedChange={(v) => setS({ ...s, quiet_enabled: v })} data-testid="quiet-enabled" /></div>
            <div className="flex items-center gap-3 text-sm"><span>Dalle</span>{sel("quiet_start")}<span>alle</span>{sel("quiet_end")}</div>
            <div className="flex items-center justify-between rounded-md border border-border px-3 py-2"><div><Label htmlFor="quiet-campaigns">Applica anche alle campagne marketing</Label><p className="text-xs text-muted-foreground">Promemoria e avvisi regolamento sono sempre inclusi</p></div><Switch id="quiet-campaigns" checked={s.quiet_apply_campaigns} onCheckedChange={(v) => setS({ ...s, quiet_apply_campaigns: v })} data-testid="quiet-campaigns" /></div>
            <Button onClick={save} disabled={busy} className="w-full" data-testid="quiet-save">{busy ? "Salvataggio…" : "Salva"}</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
